<div class="toolbar-container">
  <app-do-column-show-hide></app-do-column-show-hide>
  <app-do-toggle-expand></app-do-toggle-expand>
  <app-copy-item-button></app-copy-item-button>
  <app-delete-item-button></app-delete-item-button>
  <app-do-export-excel></app-do-export-excel>
  <app-do-export-pdf></app-do-export-pdf>
</div>
